// // stylesheets
// import './App.css';

// // fonts
// import "../fonts/quadraat.ttf"

// import { useState } from 'react'

// import { getUser } from '../utilities/users-service';
// import Main from '../components/Main/Main';
// import Footer from '../components/Footer/Footer';
// import NavBar from "../components/NavBar/NavBar"
// import Banner from '../components/Banner/Banner';


// export default function App() {

// const [user, setUser] = useState(getUser())

//   return (
//     <div className="App">
//       <Banner />
//       <NavBar user={user} setUser={setUser} />
//       <Main user={user} setUser={setUser}/>
//       <Footer />
//     </div>
//   );
// }

// above is the code from before! below is the change so we get a hard refresh that redirects to home page and clears cache to reduce bugs as of 10.1.25

// stylesheets
import './App.css';

// fonts
import "../fonts/quadraat.ttf"

import { useState, useEffect } from 'react';

import { getUser } from '../utilities/users-service';
import Main from '../components/Main/Main';
import Footer from '../components/Footer/Footer';
import NavBar from "../components/NavBar/NavBar"
import Banner from '../components/Banner/Banner';

export default function App() {
  const [user, setUser] = useState(getUser());

  // === Add: on hard refresh, clear caches and go to home ===
  useEffect(() => {
    // Detect a full page reload (not internal SPA navigation)
    const navEntries = performance.getEntriesByType('navigation');
    const isReload = navEntries.length
      ? navEntries[0].type === 'reload'
      : // fallback for older browsers
        performance?.navigation?.type === performance?.navigation?.TYPE_RELOAD;

    if (!isReload) return;

    // 1) Clear simple storage caches
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch {}

    // 2) Clear Cache Storage (used by SW/fetch)
    if ('caches' in window) {
      caches.keys().then(keys => keys.forEach(k => caches.delete(k)));
    }

    // 3) Unregister service workers (prevents stale assets served offline)
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(regs => {
        regs.forEach(r => r.unregister());
      });
    }

    // 4) (Optional) Clear IndexedDB if your app uses it
    if (window.indexedDB && indexedDB.databases) {
      indexedDB.databases().then(dbs => {
        dbs.forEach(db => {
          if (db.name) indexedDB.deleteDatabase(db.name);
        });
      });
    }
    // If you know specific DB names, you can explicitly delete them instead:
    // indexedDB.deleteDatabase('my-app-db');

    // 5) Redirect to home. Use replace() so back button doesn't return to prior route.
    if (window.location.pathname !== '/') {
      window.location.replace('/');
    }
  }, []);
  // === End add ===

  return (
    <div className="App">
      <Banner />
      <NavBar user={user} setUser={setUser} />
      <Main user={user} setUser={setUser}/>
      <Footer />
    </div>
  );
}
